import React, { useState, useContext, useEffect } from 'react';
import classNames from 'classnames';
import CloseButtonDialog from "App/components/CloseButtonDialog";
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { LayoutContext } from 'App/Layout/store'
import AddCircle from '@material-ui/icons/AddCircle';
import RemoveCircle from '@material-ui/icons/RemoveCircle';
import DeleteIcon from '@material-ui/icons/Delete';
import Icon from '@material-ui/core/Icon';
import Tooltip from '@material-ui/core/Tooltip';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import InputLabel from '@material-ui/core/InputLabel';
import Autocomplete from 'App/components/Autocomplete';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Badge from '@material-ui/core/Badge';
import Link from '@material-ui/core/Link';
import {separadorMiles, DigitoVerificador, formateaRut} from 'App/Helpers/Genericos';
import Switch from '@material-ui/core/Switch';
import ConfirmBorrador from 'App/Emitidos/ConfirmBorrador';
import _ from 'underscore';
import moment from 'moment';
import { DatosContribuyente } from 'App/Helpers/Actions';
import { useAuth } from "react-oidc-context";
import {GetContribuyentes, GetCodigosReferencia, CrearDTE} from 'App/Emitidos/Actions';
import {GetActividadEconomica} from 'App/Contribuyente/Actions';
import { NativeSelect } from '@material-ui/core';
import {Imprimir} from 'App/components/TablaDTE';

const styles = theme => ({
  table: {
    marginTop: 0,
    padding: 0,
  },
  tableCell: {
    padding: 5,
    textAlign: "center"
  },
  tableCellDelete: {
    padding: 10,
    textAlign: "center",
    cursor: "pointer"
  },
  tableCellSm: {
    /*width: 30,
    textAlign: "center"*/
  },
  textAlignRight: {
    textAlign: "right"
  },
  textAlignCenter: {
    textAlign: "center"
  },
  textAlignLeft: {
    textAlign: "left"
  },
  iconHover: {
    '&:hover': {
      color: "rgb(61,30,144)",
    }
  },
  gridContainer: {
    paddingRight: 30,
    marginTop: "0.1px"
  },
  borderRed: {
    borderStyle: "solid",
    marginTop: "0.1px",
    padding: 10,
    borderColor: "red",
    width:"100%"
  },
  totalizadores: {
    borderStyle: "solid",
    marginTop: "30px",
    padding: 10,
    borderColor: "red"
  },
  labelPaddingTop: {
    paddingTop: "10px"
  },
  paddingTop: {
    paddingTop: "11px"
  },
  totalizadoresLabel: {
    position: "relative",
    top: "6px"
  },
  whiteSpaceNowrap: {
    whiteSpace: "nowrap"
  },
  referenciasTableCell: {
    margin: 0,
    padding: 2
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  badgeStyle: {
    margin: theme.spacing.unit,
    paddingRight: "8px !important",
    marginTop: "11px !important"
  },
  fullWidth: {
    width:"100%"
  }
});

const iterate = (obj) => {
  Object.keys(obj).forEach(key => {

  if(!obj[key]){
    delete obj[key];
  }

  if(Array.isArray(obj[key]) && obj[key].length == 0){
    delete obj[key];
  }

  if (typeof obj[key] === 'object') {
          iterate(obj[key])
      }
  })
}

function Index(props) {
  const auth = useAuth();
  const [items, setItems] = useState([{ id: 0, codigo: "", cantidad: "", unidadMedida: "", precio: "", descuento: "", tipoDescuento: 0, total: "", exento: false, impuesto: 0, delete: "delete" }]); //tipoDescuento => 0: Porcentaje ; 1: Fijo
  const [tipoDocumento, setTipoDocumento] = useState();
  const [orderBy, SetOrderBy] = useState();
  const [order, SetOrder] = useState('asc');
  const [clientesSuggestion, setClientesSuggestion] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [cliente, setCliente] = useState("");
  const [giro, setGiro] = useState("");
  const [giros, setGiros] = useState([]);
  const [direccion, setDireccion] = useState("");
  //const [foliosRestantes, setFoliosRestantes] = useState();
  const [impuestosDisponibles, setImpuestosDisponibles] = useState([]);
  const [referencias, setReferencias] = useState([]);
  const [creando, setCreando] = useState(false);
  const [descuentoGlobal, setDescuentoGlobal] = useState("");
  const [tipoDescuentoGlobal, setTipoDescuentoGlobal] = useState(0); //%,$
  const [tipoMovDRGlobal, setTipoMovDRGlobal] = useState("D"); //Des,Rec
  const [contacto, setContacto] = useState("");
  const [contactoFinal, setContactoFinal] = useState("");
  const [codigoInterno, setCodigoInterno] = useState("");
  const [openConfirmBorrador, setConfirmBorrador] = useState(false);
  const [mntBruto, setMntBruto] = useState(false);
  const [cargandoClientes, setCargandoClientes] = useState(false);
  const [tipoDespacho, setTipoDespacho] = useState("");
  const [tipoTraslado, setTipoTraslado] = useState("");
  const [tipoTranVenta, setTipoTranVenta] = useState("");
  const [transporte, setTransporte] = useState({});
  const [idDte, setIdDte] = useState(null);
  const [formaPago, setFormaPago] = useState(2);
  const [fechaVencimiento, setFechaVencimiento] = useState("");

  const [codigosReferencia, setCodigosReferncia] = useState([]);

  var lfecha = moment().format("YYYY-MM-DD");
  const [fecha, setFecha] = useState(lfecha);

  useEffect(()=> {
    var impFiltered = _.filter(layoutContext.state.impuestosAdicionales, (item)=>{
      return _.findWhere(item.TiposDocumento, { IdTipoDoc: tipoDocumento })
    });
    var impDisponibles = _.map(impFiltered, (item)=> {
        return { label: item.NombreImpuesto, value: item.CodImpuesto };
    }) || [];
    setImpuestosDisponibles(impDisponibles);
    /* GetFoliosTipoDocumento(tipoDocumento, (folios)=> {
      setFoliosRestantes(folios.FoliosRestantes) */
      var newItems = _.map(items, (item)=> {
        item.impuesto = 0;
        return item;
      });
      setItems([...newItems]);
    //})
  }, [tipoDocumento]);

  useEffect(()=> {
    GetCodigosReferencia((codReferencia)=> {
      setCodigosReferncia(codReferencia);
    })
  }, []);

  const layoutContext = useContext(LayoutContext);

  var quitarText=d=>{
    console.log(d)
    if(d!=null && d._text){
      return d._text;
    }else if(typeof(d) === 'object'){
      var ret = {}
      Object.keys(d).forEach(e => ret[e] = quitarText(d[e]));
      return ret;
    }else{
      return null;
    }
  }

  useEffect(()=> {
    var dte = layoutContext.state.dteData;
    if(layoutContext.state.openNuevaVenta && layoutContext.state.tipoNuevaVenta){
      setTipoDocumento(layoutContext.state.tipoNuevaVenta)
    }
    if(dte && layoutContext.state.openNuevaVenta) {
      var items = _.map(dte.DTE.Documento.Detalle, (detalle)=>{
        return {
          codigo: (detalle.CdgItem || [{ VlrCodigo: { _text: "" } }])[0].VlrCodigo._text,
          producto: (detalle.NmbItem || {_text: ""})._text,
          descripcion: (detalle.DscItem || {_text: null})._text,
          cantidad: (detalle.QtyItem || {_text: ""})._text,
          precio: (detalle.PrcItem || {_text: ""})._text,
          total: (detalle.MontoItem || {_text: ""})._text,
          unidadMedida: (detalle.UnmdItem || {_text: ""})._text,
          descuento: (detalle.DescuentoPct || detalle.DescuentoMonto || {_text: ""})._text || "",
          tipoDescuento: 0,
          exento: ((detalle.IndExe || { _text: "0" })._text == "1" ? true : false),
          impuesto: (detalle.CodImpAdic || { _text: "" } )._text
        }
      });
      var referenciasItems = _.map((dte.DTE.Documento.Referencia || []), (item)=> {
        return {
          tipoDoc: (item.TpoDocRef||{_text:""})._text,
          numeroDoc: (item.FolioRef||{_text:""})._text,
          fechaDoc: (item.FchRef||{_text:""})._text,
          codReferencia: (item.CodRef||{_text: ""})._text,
          razonReferencia: (item.RazonRef||{_text: ""})._text
        }
      })
      setItems([...SetTotalItem(items)]);
      setTipoDocumento(dte.DTE.Documento.Encabezado.IdDoc.TipoDTE._text);
      GetContribuyentes(dte.DTE.Documento.Encabezado.Receptor.RUTRecep._text, (obj)=> {
        setContribuyente(obj[0]);
      });
      setDireccion(dte.DTE.Documento.Encabezado.Receptor.DirRecep._text);
      setContacto((dte.DTE.Documento.Encabezado.Receptor.CorreoRecep || { _text: ""})._text);
      setGiro((dte.DTE.Documento.Encabezado.Receptor.GiroRecep || { _text: ""})._text)
      setCodigoInterno((dte.DTE.Documento.Encabezado.Receptor.RUT || { _text: "" })._text);
      setFecha((dte.DTE.Documento.Encabezado.IdDoc.FchEmis || { _text: lfecha })._text);
      setDescuentoGlobal((((dte.DTE.Documento.DscRcgGlobal || { ValorDR: { _text: "" } })||{}).ValorDR||{})._text||"");
      setFechaVencimiento((dte.DTE.Documento.Encabezado.IdDoc.FchVenc || { _text: "" })._text || "");
      setReferencias(referenciasItems);
      if(dte.DTE.Documento.Encabezado.IdDoc.TipoDTE._text==39||dte.DTE.Documento.Encabezado.IdDoc.TipoDTE._text==41){
        setMntBruto(!(dte.DTE.Documento.Encabezado.IdDoc.IndMntNeto!==undefined))
      }else{
        setMntBruto(dte.DTE.Documento.Encabezado.IdDoc.MntBruto!==undefined)
      }
      setIdDte(dte.DTE.Documento.Encabezado.IdDoc.IdDte)
      setTransporte(quitarText(dte.DTE.Documento.Encabezado.Transporte))
      /*setItems([]);
      setTipoDocumento();
      SetOrderBy();
      SetOrder("asc");
      setClientesSuggestion([]);
      setClientes([]);
      setCliente("");
      setGiro("");
      setDireccion("");
      setFoliosRestantes();
      setImpuestosDisponibles([]);
      setReferencias([]);
      setTipoDescuentoGlobal(0);
      setContacto("");
      setCodigosReferncia([]);*/
   }
  }, [layoutContext.state.dteData, layoutContext.state.openNuevaVenta])

  const handleToggleModal = () => {
    setItems([{ id: 0, codigo: "", cantidad: "", unidadMedida: "", precio: "", descuento: "", tipoDescuento: 0, total: "", exento: false, impuesto: 0, delete: "delete" }]);
    setTipoDocumento();
    SetOrderBy();
    SetOrder("asc");
    setClientesSuggestion([]);
    setClientes([]);
    setCliente("");
    setGiro("");
    setGiros([]);
    setDireccion("");
    //setFoliosRestantes();
    setImpuestosDisponibles([]);
    setReferencias([]);
    setTipoDescuentoGlobal(0);
    setTipoMovDRGlobal("D");
    setContacto("");
    setCodigoInterno("");
    setDescuentoGlobal("");
    setFecha(lfecha);
    setMntBruto(false);
    setTipoTraslado("");
    setTipoDespacho("");
    setTipoTranVenta("");
    setFormaPago(2);
    setFechaVencimiento("");
    layoutContext.dispatch({ type: "setDteData", dteData: null });
    layoutContext.dispatch({ type: "toggleNuevaVenta" });
  }
  const { classes } = props;
  var id = 0;
  var esAdmin = layoutContext.state.datosEmpresa?.Permisos?.some(p => p.Nombre.startsWith("Administracion") && p.BLectura+p.BEscritura)

  //Totalizadores
  
  if(layoutContext.state.openNuevaVenta){

    var descuento_global = descuentoGlobal == "" ? 0 : descuentoGlobal;

    var items_afecto = _.filter(items, (item) => { return !item.exento&&tipoDocumento!=34&&tipoDocumento!=41; });
    var items_exento = _.filter(items, (item) => { return item.exento||tipoDocumento==34||tipoDocumento==41; });

    var neto_afecto = Math.round(items_afecto.reduce((s, i) => {
      let total = i.total*1//(i.cantidad ? parseFloat(i.cantidad) : 0) * (i.precio ? parseFloat(i.precio) : 0);
      /* let descuento = i.descuento != "" ? (i.tipoDescuento == 0 ? Math.round((i.descuento/100) * total) : i.descuento) : 0;
      total -= descuento; */
      return s + total;
    }, 0));

    var neto_exento = Math.round(items_exento.reduce((s, i) => {
      let total = i.total*1;//(i.cantidad ? parseFloat(i.cantidad) : 0) * (i.precio ? parseFloat(i.precio) : 0);
      /* let descuento = i.descuento != "" ? (i.tipoDescuento == 0 ? Math.round((i.descuento/100) * total) : i.descuento) : 0;
      total -= descuento; */
      return s + total;
    }, 0));

    //Deberia haber un indicador de cómo afecta el descuento (exento, afecto, nf)

    descuento_global = tipoDescuentoGlobal == 1 ? ((descuentoGlobal/neto_afecto) * 100) : descuentoGlobal;

    neto_afecto += (tipoMovDRGlobal == "R"?1:-1)*(neto_afecto > 0 ? (tipoDescuentoGlobal == 0 ? (neto_afecto * (descuentoGlobal/100)) : descuentoGlobal) : 0);
    var neto_afecto_bruto = neto_afecto;
    if(mntBruto){
      neto_afecto = Math.round(neto_afecto/1.19)
    }

    var neto = Math.round(neto_afecto + neto_exento);

    var iva = Math.round(neto_afecto * 0.19); //TODO: Comportamiento c/IVA // +IVA

    if(mntBruto){
      iva = neto_afecto_bruto-neto_afecto;
    }

    var impuesto_adicional = Math.round(items.reduce((s, i)=> {
      var imp = _.findWhere(layoutContext.state.impuestosAdicionales, { CodImpuesto : i.impuesto*1, BRetenidoAdicional: false });
      return (imp ? (s + (i.total * imp.TasaImpuesto/100)) : s) + 0;
    }, 0));

    var impuesto_retenido = Math.round(items.reduce((s, i)=> {
      var imp = _.findWhere(layoutContext.state.impuestosAdicionales, { CodImpuesto : i.impuesto*1, BRetenidoAdicional: true });
      return (imp ? (s + (i.total * imp.TasaImpuesto/100)) : s) + 0;
    }, 0));

    var total = neto + iva + impuesto_adicional - impuesto_retenido;
  }

  const headers = [
    { id: 'codigo', numeric: false, style:{minWidth:75,maxWidth:75}, label: 'Codigo' },
    { id: 'producto', numeric: false, style:{minWidth:250}, label: 'Nombre *' },
    { id: 'cantidad', numeric: true, style:{minWidth:75,maxWidth:75}, label: 'Cantidad' },
    { id: 'unidad', numeric: false, style:{minWidth:75,maxWidth:75}, label: 'Unidad de Medida' },
    { id: 'precio', numeric: true, style:{minWidth:100,maxWidth:100}, label: 'Precio' },
    { id: 'descuento', numeric: true, label: 'Descuento'},
    { id: 'total', numeric: true, style:{minWidth:150,maxWidth:150}, label: 'Total *' },
    { id: 'exento', numeric: false, label: 'Exento' },
    { id: 'imp_adicional', numeric: false, label: 'Impuesto' },
    { id: 'delete', numeric: true, label: '' }
  ];

  var createSortHandler = property => event => {
    handleSort(event, property);
  };

  function handleSort(evt, newOrderBy) {
    if (orderBy === newOrderBy) {
      if (order === 'desc')
        SetOrder('asc');
      else
        SetOrder('desc');
    }
    SetOrderBy(newOrderBy);
  }

  function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  }

  function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
  }

  function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function SetTotalItem(ti,ix=null){
    var calcula = (tempItems,index)=>{
      if(tempItems[index].cantidad!="" || tempItems[index].precio != ""){
        var _total = (tempItems[index].cantidad ? parseFloat(tempItems[index].cantidad) : 0) * (tempItems[index].precio ? parseFloat(tempItems[index].precio) : 0);
        var descuento = tempItems[index].descuento != "" ? (tempItems[index].tipoDescuento == 0 ? Math.round((tempItems[index].descuento/100) * _total) : tempItems[index].descuento) : 0;
        _total -= descuento;
          tempItems[index].total = Math.round(_total);
      }
    }
    if(ix){
      calcula(ti,ix);
    }else{
      for(ix = 0;ix<ti.length;ix++){
        calcula(ti,ix)    
      } 
    }
    return ti;
  }

  function ChangeValues(index, target, evt) {
    evt.preventDefault();
    var tempItems = items;
    if(target == "exento") {
      tempItems[index][target] = !tempItems[index][target];
    }else if(target == "precio"){
        var text = evt.target.value.replace(",",".");
        if(text[text.length-1]=="."||text==""){
          tempItems[index][target] = text;
        }else{
          tempItems[index][target] = (Math.round(parseFloat(evt.target.value.replace(",",".")) * 1000000) / 1000000).toString()
        }
    }else if(target == "producto"){
      tempItems[index][target] = evt.target.value.substring(0,80);
    }else if(target == "descripcion"){
      tempItems[index][target] = evt.target.value==null?null:evt.target.value.substring(0,1000);
    }else{
      tempItems[index][target] = evt.target.value;
    }
    
    setItems([...SetTotalItem(tempItems,index)]);
  }

  function changeDireccion(e){
    setDireccion(e.target.value)
  }

  function changeTipoDocumento(e) {
    var tipoDocumento = e.target.value;
    setTipoDocumento(tipoDocumento); 
    if(!layoutContext.state.dteData){
      if((tipoDocumento==39 || tipoDocumento == 41)){
        setMntBruto(true);
      }else{
        setMntBruto(false);
      }
    }else{
      if(!(tipoDocumento==52||tipoDocumento==33||tipoDocumento==34)){
        setTipoDespacho("")
      }
      if(tipoDocumento!=52){
        setTipoTraslado("")
      }
      if(!(tipoDocumento>0&&tipoDocumento!=56&&tipoDocumento!=39&&tipoDocumento!=41)){
        setTipoTranVenta("")
      }
    }
    
  }

  function pushReferencia(referencia) {
    var refs = referencias;
    refs.push(referencia);
    setReferencias([...refs]);
  }

  function removeReferencia(ix) {
    var refs = referencias;
    refs.splice(ix, 1);
    setReferencias([...refs]);
  }

  function changeReferenciaData(ix, target, evt) {
    var refs = referencias;
    refs[ix][target] = evt.target.value;
    setReferencias([...refs]);
  }

  function changeDescuentoGlobal(evt) {
    setDescuentoGlobal(evt.target.value);
  }

  function changeContacto(evt) {
    setContacto(evt.target.value);
  }

  function changeCodigoInterno(evt) {
    setCodigoInterno(evt.target.value);
  }

  function toggleConfirmBorrador() {
    /* if(layoutContext.state.dteData) {
      guardarDTE(false);
    } else { */
      setConfirmBorrador(!openConfirmBorrador);
    //} 
  }

  function guardarDTE(borrador) {
    //if(!layoutContext.state.dteData) {
      toggleConfirmBorrador();
      setCreando(true);
    //}
    var errores = [];
    if(!tipoDocumento || tipoDocumento == "") {
      errores.push("Debe escojer el tipo de documento");
    }
    if (!cliente || cliente == "") {
      errores.push("Debe escojer un cliente");
    }
    if(items.length == 0) {
      errores.push("No hay cargos o items a facturar");
    }
    if(tipoDocumento == 52 && !(tipoTraslado>0)){
      errores.push("Guías de despacho deben tener Tipo de Traslado");
    }
    if((tipoDocumento == 61 || tipoDocumento == 56) && !(referencias.some(o => o.codReferencia))){
      errores.push("Debe seleccionar un Código de Referencia");
    }
    if(fechaVencimiento && fechaVencimiento.trim() && fechaVencimiento<fecha){
      errores.push("Fecha de Vencimiento debe ser mayor a la Fecha de Emisión");
    }

    if(errores.length == 0) {
      var DTE = {
            Encabezado: {
              IdDoc: {
                TipoDTE: tipoDocumento,
                FchEmis: fecha,
                //Folio: null
              },
              Receptor: {
                RUTRecep: (cliente.Rut + "-" + DigitoVerificador(cliente.Rut)),
                RznSocRecep: cliente.RazonSocial,
                GiroRecep: giro,
                DirRecep: direccion,
                CmnaRecep: cliente.Comuna.Nombre,
                CiudadRecep: cliente.Comuna.Ciudad,
                /*DirPostal: direccion, 
                CmnaPostal: cliente.Comuna.Nombre, 
                CiudadPostal: cliente.Comuna.Provincia.Nombre,
                */
                CorreoRecep: contactoFinal ? contactoFinal:null,
                //CdgIntRecep: codigoInterno == "" ? null : codigoInterno
              },
              Totales: {
                TasaIVA: 19, //¿Puede ser otro valor, y de ser así, de dónde obtenerlo?
                MntExe: neto_exento,
                MntTotal: total,
                /*MontoNF,
                MontoPeriodo,
                SaldoAnterior,
                VlrPagar,*/
                MntNeto: neto,
                IVA: iva
              }
            }
      }
      var detalles = [];
      for(var i = 0; i < items.length; i++) {
        var tipoDcto = items[i].tipoDescuento;

        var descuento = items[i].descuento == "" ? 0 : items[i].descuento;

        var detalle = {
          NroLinDet: i + 1,
          NmbItem: items[i].producto,
          DscItem: items[i].descripcion,
          QtyItem: items[i].cantidad,
          PrcItem: items[i].precio,
          UnmdItem: items[i].unidadMedida,
          DescuentoPct: tipoDcto == 0 ? parseFloat(descuento) : ((items[i].precio/(items[i].cantidad * items[i].precio))*100),
          DescuentoMonto: tipoDcto == 0 ? Math.round((items[i].cantidad * items[i].precio)*parseFloat(descuento)/100) : parseFloat(descuento),
          MontoItem: items[i].total
        }

        if(items[i].exento) {
          detalle.IndExe = 1;
        }

        if(items[i].impuesto != 0) {
          detalle.CodImpAdic = items[i].impuesto;
        }

        if(items[i].codigo != "") {
          var Codigos = [];
          //TODO: integrar posibilidad de códigos tipo EAN, PLU y DUN
          var codigo = {
            TpoCodigo: 'Interno',
            VlrCodigo: items[i].codigo
          }
          Codigos.push(codigo);
        
          detalle.CdgItem = Codigos;
        }
        detalles.push(detalle);
      }
      DTE.Detalle = detalles;

      if(mntBruto){
        if(!(tipoDocumento == 39 || tipoDocumento == 41)){
          DTE.Encabezado.IdDoc.MntBruto = 1;
        }
      }else{
        if(tipoDocumento == 39 || tipoDocumento == 41){
          DTE.Encabezado.IdDoc.IndMntNeto = 2
        }
      }
      if(tipoDespacho){
        DTE.Encabezado.IdDoc.TipoDespacho = tipoDespacho;
      }
      if(tipoTraslado){
        DTE.Encabezado.IdDoc.IndTraslado = tipoTraslado;
      }
      if(tipoTranVenta>1){
        DTE.Encabezado.IdDoc.TpoTranVenta = tipoTranVenta;
      }
      if(formaPago && formaPago != 2){
        DTE.Encabezado.IdDoc.FmaPago = formaPago;
      }
      if(fechaVencimiento && fechaVencimiento.trim()){
        DTE.Encabezado.IdDoc.FchVenc = fechaVencimiento;
      }
      if(idDte){
        DTE.Encabezado.IdDoc.IdDte = idDte;
      }

      var refs = [];
      for(var i = 0; i < referencias.length;i++) {
        var ref = {
          NroLinRef: i + 1,
          TpoDocRef: referencias[i].tipoDoc,
          FolioRef: referencias[i].numeroDoc,
          FchRef: referencias[i].fechaDoc,
          CodRef: referencias[i].codReferencia,
          RazonRef: referencias[i].razonReferencia
        }
        refs.push(ref);
      }
      DTE.Referencia = refs;

      if(descuentoGlobal != "") {
        DTE.DscRcgGlobal = {
          NroLinDR: 1,
          TpoMov: tipoMovDRGlobal,
          TpoValor: !tipoDescuentoGlobal?"%":"$",
          ValorDR: descuentoGlobal
          //IndExeDR: 1 Solo para exentos o NF
        }
      }

      if(!_.isEmpty(transporte)){
        DTE.Encabezado.Transporte = transporte;
      }

      iterate(DTE)
      delete DTE.Encabezado.Totales
      //DTE.Encabezado.IdDoc.Folio = null;
      CrearDTE([DTE], false, borrador, (dtes)=>{
        var plural = dtes.length>1?"s":"";
        var errores = _.filter(dtes, e => e.DTE.Error);
            if (errores.length > 0) {
                var ix = 1;
                var errorList = dtes.reduce((s, i) => {
                    return s + (ix++ + ") " + (i.DTE.Error ? i.DTE.Error : "Enviado exitosamente") + "\n");
                }, "");
                alert("Se han encontrado las siguientes observaciones al enviar documento"+plural+":\n" + errorList);
            } else {
                if(!esAdmin){
                  Imprimir(1, dtes.map(e => ({id_dte:e.DTE.Id})))
                }else{
                  alert("Documento"+plural+" creado"+plural+" con exito")
                }
            }
        layoutContext.dispatch({ type: "toggleNuevaVenta" });
        setCreando(false);
      }, (error)=> {
        //alert(error)
        layoutContext.dispatch({ type: "toggleNuevaVenta" });
        setCreando(false);
      });

    } else {
      var errorList = errores.reduce((s, i)=> {
        return s + "\n-" + i;
      }, "");
      alert("Se han encontrado los siguientes errores al guardar el documento:" + errorList);
      setCreando(false);
    }
  }
  

  function setContribuyente(contribuyente) {
    setGiros([]);
    setGiro("");
    setDireccion("");
    setContacto("");
    setCliente(contribuyente.RazonSocial ? contribuyente : _.findWhere(clientes, { Rut: contribuyente.Rut }));
    if(contribuyente.Direccion){setDireccion(contribuyente.Direccion)}
    if(contribuyente.ActividadEconomica){setGiros(contribuyente.ActividadEconomica);setGiro(contribuyente.ActividadEconomica.length?contribuyente.ActividadEconomica[0].Nombre:"")}
    if(contribuyente.Correo){setContacto(contribuyente.Correo)}
    var rut = separadorMiles(contribuyente.Rut)+ "-" + DigitoVerificador(contribuyente.Rut)
    setCodigoInterno(rut)
  }

  const content = !layoutContext.state.openNuevaVenta?null:(
    <Grid direction="column" container>
      <ConfirmBorrador open={openConfirmBorrador} guardarDTE={guardarDTE} handleClose={toggleConfirmBorrador} />
      <Grid container>
        <Grid item xs={12} sm container style={{flexWrap:"nowrap"}}>
          <Grid item style={{flexWrap:"nowrap"}} container direction="column" xs={4} spacing={8} className={classes.gridContainer}>
            <Grid item>
              <FormControl fullWidth>
                <Autocomplete 
                  label="Cliente/RUT" 
                  suggestions={clientesSuggestion} 
                  placeholder="Nombre o RUT de Cliente" 
                  isMulti={false}
                  cargando={cargandoClientes}
                  inputChange={_.debounce((nombre) => {
                    setCargandoClientes(true);
                    GetContribuyentes(nombre.trim(), (clientes)=> {
                      setClientes(clientes);
                      setClientesSuggestion(_.map(clientes, (cliente) => { return { label: cliente.RazonSocial, value: cliente.Rut } }));
                      setCargandoClientes(false);
                    });
                  }, 500)}
                  value={cliente == "" ? null : { label: cliente.RazonSocial, value: cliente.Rut }}
                  onChange={(selected)=> {
                      var contribuyente = _.find(clientes,{Rut: selected.value});
                      setContribuyente(contribuyente);
                      DatosContribuyente(selected.value+"-"+DigitoVerificador(selected.value),k=>!_.all(k.actividades,e => _.any(contribuyente.ActividadEconomica||[],{ID: e.codigo}))||!(contribuyente.ActividadEconomica||[]).length ? setGiros((k.actividades||[]).map((a,i) => {if(i == 0){setGiro(a.giro);} return {ID: a.codigo, Nombre: a.giro}})):null,()=>{})
                  }}
                  /> 
              </FormControl>
            </Grid>
            <Grid item style={{flexWrap:"nowrap"}}>
              <FormControl fullWidth>
                {!Array.isArray(giros) || giros.length==0?
                <TextField label="Giro" onChange={e=>setGiro(e.target.value)} className={classes.dense} value={giro} />
                :
                <TextField
                  select
                  fullWidth
                  label="Giro"
                  margin="dense"
                  InputLabelProps={{ shrink: true }}
                  className={classes.dense}
                  value={giro}
                  onChange={e=>{e.target.value == "Manual"?setGiros([]):setGiro(e.target.value)}}>
                  {/* Falta filtrar por compra o venta */}
                  {giros.map(option => (
                    <MenuItem key={option.ID} value={option.Nombre}>
                      {option.Nombre}
                    </MenuItem>
                  ))}
                  <MenuItem key={-10} value ="Manual">
                      Ingresar Manualmente...
                    </MenuItem>
                </TextField>
                }
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl fullWidth>
                <TextField label="Direccion" onChange={changeDireccion} className={classes.dense} value={direccion} />
              </FormControl>
            </Grid>
            <Grid item container>
            <Grid item xs = {6}>
              <FormControl fullWidth>
                <TextField label="Comuna" onChange={e=>setCliente({...(cliente||{}),Comuna:{...(cliente.Comuna||{}),Nombre:e.target.value}})} className={classes.dense} value={(cliente.Comuna||{}).Nombre||""} />
              </FormControl>
            </Grid>
            <Grid item xs = {6}>
              <FormControl fullWidth>
                <TextField label="Ciudad" onChange={e=>setCliente({...(cliente||{}),Comuna:{...(cliente.Comuna||{}),Ciudad:e.target.value}})} className={classes.dense} value={(cliente.Comuna||{}).Ciudad||""} />
              </FormControl>
            </Grid>
            </Grid>
            <Grid item className={classes.fullWidth}>
              <FormControl fullWidth>
                <TextField label="RUT" className={classes.dense} onChange={changeCodigoInterno} value={codigoInterno} />
              </FormControl>
            </Grid>
          </Grid>
          <Grid item style={{flexWrap:"nowrap"}} container direction="column" xs={4} spacing={8} className={classes.gridContainer}>
            <Grid item>
              <FormControl fullWidth>
                <TextField label="Fecha de Emisión" type="date" onChange={e=>setFecha(e.target.value)} value={fecha} />
              </FormControl>
            </Grid>
            {[33,34,39,41].includes(tipoDocumento)?
            <Grid item>
              <FormControl fullWidth>
                <TextField label="Fecha de Vencimiento" type="date" onChange={e=>setFechaVencimiento(e.target.value)} value={fechaVencimiento || ""} InputLabelProps={{ shrink: true }} />
              </FormControl>
            </Grid>:null}
            <Grid item className={classes.fullWidth}>
              <FormControl fullWidth>
                <TextField label={"Correo Receptor"} className={classes.dense} value={contacto} disabled />
              </FormControl>
            </Grid>
            <Grid item className={classes.fullWidth}>
              <FormControl fullWidth>
                <TextField label={"Otro Correo Receptor"} className={classes.dense} onChange={e => setContactoFinal((e.target.value||"").slice(0,80))} value={contactoFinal} />
              </FormControl>
            </Grid>
            {tipoDocumento==52||tipoDocumento==33||tipoDocumento==34? //Faltan docs
            <Grid item className={classes.fullWidth}>
              <FormControl fullWidth>
              <TextField
                  select
                  fullWidth
                  label="Tipo de Despacho"
                  margin="dense"
                  InputLabelProps={{ shrink: true }}
                  className={classes.dense}
                  value={tipoDespacho||""}
                  onChange={e=>setTipoDespacho(e.target.value)}>
                  {/* Falta filtrar por compra o venta */}
                  {[
                    {ID:1,Nombre:"Por cuenta del receptor del documento"},
                    {ID:2,Nombre:"Por cuenta del emisor a instalaciones del cliente"},
                    {ID:3,Nombre:"Por cuenta del emisor a otras instalaciones"}
                  ].map(option => (
                    <MenuItem key={option.ID} value={option.ID}>
                      {option.Nombre}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </Grid>:null}
            {tipoDocumento==52?
            <Grid item className={classes.fullWidth}>
              <FormControl fullWidth>
              <TextField
                  select
                  fullWidth
                  label="Tipo de Traslado"
                  margin="dense"
                  InputLabelProps={{ shrink: true }}
                  className={classes.dense}
                  value={tipoTraslado||""}
                  onChange={e=>setTipoTraslado(e.target.value)}>
                  {/* Falta filtrar por compra o venta */}
                  {[
                    {ID:1,Nombre:"Operación constituye venta"},
                    {ID:2,Nombre:"Ventas por efectuar"},
                    {ID:3,Nombre:"Consignaciones"},
                    {ID:4,Nombre:"Entrega gratuita"},
                    {ID:5,Nombre:"Traslados internos"},
                    {ID:6,Nombre:"Otros traslados no venta"},
                    {ID:7,Nombre:"Guía de devolución"},
                    {ID:8,Nombre:"Traslado para exportación (no venta)"},
                    {ID:9,Nombre:"Venta para exportación"},
                  ].map(option => (
                    <MenuItem key={option.ID} value={option.ID}>
                      {option.Nombre}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </Grid>:null}
          </Grid>
          <Grid item container direction="column" xs={4} spacing={8} className={classes.gridContainer}>
            <div className={classes.borderRed}>
              <Grid item>
                <Typography color="error">{layoutContext.state.datosEmpresa.RazonSocial}, RUT: {layoutContext.state.datosEmpresa ? (separadorMiles(layoutContext.state.datosEmpresa.Rut) + "-" + layoutContext.state.datosEmpresa.Dv): "No especifíca"}</Typography>
              </Grid>
              <Grid item>
                <TextField
                  select
                  fullWidth
                  label="Tipo Venta"
                  margin="dense"
                  InputLabelProps={{ shrink: true }}
                  className={classes.dense}
                  value={tipoDocumento||""}
                  onChange={changeTipoDocumento}>
                  {/* Falta filtrar por compra o venta */}
                  {layoutContext.state.tiposDoc.filter(o => o.Electronico)
                  .filter(o => layoutContext.state.datosEmpresa?.Permisos?.some(d => d.Nombre == "Emitidos" && (!d.TiposDoc.filter(f => f > 0).length || d.TiposDoc.includes(o.ID)) ))
                  .map(option => (
                    <MenuItem key={option.ID} value={option.ID}>
                      {option.Nombre}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              {/* <Grid item>
                <Typography color="error" className={classes.labelPaddingTop}>{ foliosRestantes ? foliosRestantes > 0 ?  "Quedan " + foliosRestantes + " folios" : "No hay folios para el tipo de documento solicitado" :  "No hay folios para el tipo de documento solicitado"}</Typography>
              </Grid> */}
            </div>
            <div className={classes.paddingTop} />
            {
              tipoDocumento>0&&tipoDocumento!=56&&tipoDocumento!=39&&tipoDocumento!=41? // Faltan otros tipos
            <Grid>
            <FormControl fullWidth>
              <TextField
                  select
                  fullWidth
                  label="Tipo Transacción de Venta"
                  margin="dense"
                  InputLabelProps={{ shrink: true }}
                  className={classes.dense}
                  value={tipoTranVenta<2?1:tipoTranVenta}
                  onChange={e=>setTipoTranVenta(e.target.value)}>
                  {/* Falta filtrar por compra o venta */}
                  {[
                    {ID:1,Nombre:"Ventas del Giro"},
                    {ID:2,Nombre:"Venta Activo Fijo"},
                    {ID:3,Nombre:"Venta Bien Raíz"},
                  ].map(option => (
                    <MenuItem key={option.ID} value={option.ID}>
                      {option.Nombre}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </Grid>:null}
            {[33,34,43,46,56,61].includes(tipoDocumento)?
            <Grid item className={classes.fullWidth}>
              <FormControl fullWidth>
              <TextField
                  select
                  fullWidth
                  label="Forma de Pago"
                  margin="dense"
                  InputLabelProps={{ shrink: true }}
                  className={classes.dense}
                  value={formaPago||2}
                  onChange={e=>setFormaPago(e.target.value)}>
                  {/* Falta filtrar por compra o venta */}
                  {[
                    {ID:1,Nombre:"Contado"},
                    {ID:2,Nombre:"Crédito"},
                    {ID:3,Nombre:"Sin Costo (Entrega Gratuita)"},
                  ].map(option => (
                    <MenuItem key={option.ID} value={option.ID}>
                      {option.Nombre}
                    </MenuItem>
                  ))}
                </TextField>
              </FormControl>
            </Grid>:null}
            {
              tipoDocumento>0&&tipoDocumento!=52? // Faltan otros tipos
            <Grid className = {classes.paddingTop}>
            <FormControlLabel
          control={
            <Switch
              checked={mntBruto}
              onChange={()=>setMntBruto(!mntBruto)}
              color="primary"
            />
          }
          label={"Montos "+(mntBruto?"Brutos":"Netos")}
        />
            </Grid>
            :null}
          </Grid>
        </Grid>
      </Grid >
      <Grid item xs container>
        <Grid item xs={12} className={classes.textAlignRight}>
          <Tooltip title="Agregar item">
            <Icon color="primary" aria-label="Add" className={classes.iconHover} onClick={(evt) => {
              evt.preventDefault();
              var newItems = items;
              var maxId = _.max(items, function (item) { return item.id; });
              newItems.push({ id: (maxId && items.length) ? (maxId.id + 1) : 0, codigo: "", cantidad: "", unidadMedida: "", precio: "", descuento: "", tipoDescuento: 0, total: "", exento: false, impuesto: 0, delete: "delete" }); //tipoDescuento => 0: Porcentaje ; 1: Fijo
              setItems([...newItems]);
            }}>
              <AddCircle />
            </Icon>
          </Tooltip>
        </Grid>
        <Grid item xs={12}>
          <div style={{ height: 300, maxHeight: 300, overflowY: "auto" }}>
            <Table className={classes.table} size="small">
              <TableHead>
                <TableRow>
                  {
                    headers.map(row => {
                      if(row.id == "imp_adicional" && !impuestosDisponibles.length){
                        return null;
                      }
                        
                      return (
                        <TableCell
                          className={[classes.tableCell, classes.textAlignLeft].join(" ")}
                          key={row.id}
                          numeric={row.numeric}
                          sortDirection={orderBy === row.id ? order : false}
                          onRequestSort={handleSort}
                        >
                          {/* <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={createSortHandler(row.id)}
                          > */}
                            {row.label}
                          {/* </TableSortLabel> */}
                        </TableCell>
                      );
                    }, this)
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                {
                  stableSort(items, getSorting(order, orderBy)).map((row, ix) => {
                    return (
                      <TableRow key={row.id}>
                        <TableCell className={classes.tableCell} component="th" scope="row" style={{minWidth:75,maxWidth:75}}><TextField onChange={(e)=> { ChangeValues(ix, "codigo", e) }} value={row.codigo} /></TableCell>
                        <TableCell style={{minWidth:250}} className={classes.tableCell} >
                          <FormControl fullWidth>
                            <Input
                              id={"nombre"+ix}
                              onChange={(e)=> { ChangeValues(ix, "producto", e) }} 
                              value={row.producto}
                              multiline
                              fullWidth
                              inputProps={{
                                style: {fontSize: 13} 
                              }}
                              endAdornment={
                                row.descripcion!==null&&row.descripcion!==undefined?<InputAdornment position="end">
                                <IconButton
                                  aria-label="MasTexto"
                                  onClick={e=>{e.target.value=null;ChangeValues(ix, "descripcion", e)}}
                                >
                                  <RemoveCircle fontSize="small"/>
                                </IconButton>
                              </InputAdornment>:<InputAdornment position="end">
                                  <IconButton
                                    aria-label="MasTexto"
                                    onClick={e=>{e.target.value="";ChangeValues(ix, "descripcion", e)}}
                                  >
                                    <AddCircle fontSize="small"/>
                                  </IconButton>
                                </InputAdornment>
                              }
                            />
                          </FormControl>
                          {row.descripcion!==null&&row.descripcion!==undefined?<TextField fullWidth multiline inputProps={{
                                style: {fontSize: 13} 
                              }} placeholder="Descripcion" onChange={(e)=> { ChangeValues(ix, "descripcion", e) }} value={row.descripcion} />:null}
                        </TableCell>
                        <TableCell className={classes.tableCell} numeric style={{minWidth:75,maxWidth:75}}><TextField onChange={(e)=> { ChangeValues(ix, "cantidad", e) }} value={row.cantidad}/></TableCell>
                        <TableCell className={classes.tableCell} numeric style={{minWidth:75,maxWidth:75}}>
                          <FormControl fullWidth className={classes.formControl}>
                            <Select
                              native
                              value={row.unidadMedida}
                              onChange={(e)=> { ChangeValues(ix, "unidadMedida", e) }}
                              input={<Input value={row.unidadMedida} />}
                            >
                              <option value=""></option>
                              <option value="UN">UN</option>
                              <option value="BIDO">BIDO</option>
                              <option value="BOLS">BOLS</option>
                              <option value="BOTE">BOTE</option>
                              <option value="CAJA">CAJA</option>
                              <option value="CM">CM</option>
                              <option value="DIA">Día</option>
                              <option value="DP">DP</option>
                              <option value="FRAS">FRAS</option>
                              <option value="HORA">Hora</option>
                              <option value="KG">KG</option>
                              <option value="KM">KM</option>
                              <option value="KM2">KM2</option>
                              <option value="KWH">KWh</option>
                              <option value="LT">LT</option>
                              <option value="M2">M2</option>
                              <option value="M3">M3</option>
                              <option value="MES">Mes</option>
                              <option value="MG">MG</option>
                              <option value="MT">MT</option>
                              <option value="PAQU">PAQU</option>
                              <option value="PAR">PAR</option>
                              <option value="SACH">SACH</option>
                              <option value="SEMA">Sema</option>
                              <option value="T">T</option>
                              <option value="TARR">TARR</option>
                              <option value="TIRA">TIRA</option>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell className={classes.tableCell} numeric style={{minWidth:100,maxWidth:100}}><TextField onChange={(e)=> { ChangeValues(ix, "precio", e) }} value={row.precio.replace(".",",")} /></TableCell>
                        <TableCell className={classes.tableCell} numeric style={{minWidth:75,maxWidth:100}}>
                          <FormControl className={classNames(classes.margin, classes.textField)}>
                            <Input
                              onChange={(e)=> { ChangeValues(ix, "descuento", e) }}
                              type="number"
                              value={row.descuento}
                              endAdornment={
                                <InputAdornment position="end">
                                  <IconButton
                                    aria-label="Cambiar tipo de descuento"
                                    title="Cambiar tipo de descuento"
                                    onClick={()=> { 
                                      ChangeValues(ix, "tipoDescuento", { 
                                        target: { value: (row.tipoDescuento == 0 ? 1 : 0) },
                                        preventDefault(){}
                                      }) }}
                                  >
                                    {row.tipoDescuento == 0 ? <Icon style={{lineHeight:0.5, textAlign:"center", fontWeight: "bold", fontSize: 14}}>%</Icon> : row.tipoDescuento == 1 ? <Icon style={{lineHeight:0.5, textAlign:"center", fontWeight: "bold", fontSize: 14}}>$</Icon> : "" }
                                  </IconButton>
                                </InputAdornment>
                              }
                            />
                          </FormControl>
                        </TableCell>
                        <TableCell className={classes.tableCell} numeric style={{minWidth:150,maxWidth:150}}><TextField onChange={e=>ChangeValues(ix,'total',e)} value={row.total} /></TableCell>
                        <TableCell className={classes.tableCell}>
                          <Switch checked={row.exento||tipoDocumento==34||tipoDocumento==41} onClick={(e)=> { ChangeValues(ix, "exento", e) } } />
                        </TableCell>
                        {impuestosDisponibles.length?<TableCell className={classes.tableCell}>
                         <Select
                              native
                              value={row.impuesto}
                              onChange={(e)=> { ChangeValues(ix, "impuesto", e); }}
                              fullWidth
                              input={<Input value={row.impuesto} />}
                            >
                              <option value={0}></option>
                              {
                                impuestosDisponibles.map((item)=> {
                                  return <option value={item.value}>{item.label}</option>
                                })
                              }
                              
                          </Select>
                          
                        </TableCell>:null}
                        <TableCell className={classes.tableCellDelete+" "+classes.textAlignCenter} onClick={() => {
                          if(items.length>1){
                            var tempItems = items;
                            tempItems.splice(ix, 1);
                            setItems([...tempItems]);
                          }
                        }}>
                          <Icon color="secondary">
                            <DeleteIcon />
                          </Icon>
                        </TableCell>
                      </TableRow>
                    );
                  })
                }
              </TableBody>
            </Table>
          </div>
        </Grid>
        <Grid item sm={4} xs></Grid>
        <Grid item sm={4} container direction="column" spacing={8} className={classes.gridContainer}>
          <div className={classes.totalizadores}>
            <Grid container>
              <Grid item xs={5}>
                <InputLabel className={classes.totalizadoresLabel}>
                  <Link color="inherit" href="#" onClick={e => {e.preventDefault();setTipoMovDRGlobal(tipoMovDRGlobal=="D"?"R":"D")}}>
                  {tipoMovDRGlobal=="D"?"Descuento":"Recargo"} global
                  </Link>
                  </InputLabel>
              </Grid>
              <Grid item xs={7}>
                <FormControl className={classNames(classes.margin, classes.textField)}>
                  <Input
                    onChange={(e)=> { changeDescuentoGlobal(e); }}
                    value={descuentoGlobal}
                    type="number"
                    endAdornment={
                      <InputAdornment position="end">
                        <Button
                          aria-label="Cambiar tipo de descuento"
                          title={!tipoDescuentoGlobal?"Descuento porcentual":"Descuento en pesos"}
                          onClick={()=> { 
                            setTipoDescuentoGlobal(!tipoDescuentoGlobal)
                          }}
                        >
                          {tipoDescuentoGlobal == 0 ? <Icon style={{lineHeight:0.5, textAlign:"center", fontWeight: "bold", fontSize: 14}}>%</Icon> : tipoDescuentoGlobal == 1 ? <Icon style={{lineHeight:0.5, textAlign:"center", fontWeight: "bold", fontSize: 14}}>$</Icon> : "" }
                        </Button>
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={5}>
                <InputLabel className={classes.totalizadoresLabel}>Impuesto retenido</InputLabel>
              </Grid>
              <Grid item xs={7}>
                <FormControl fullWidth>
                  <TextField className={classes.dense} value={impuesto_retenido} disabled/>
                </FormControl>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={5}>
                <InputLabel className={classes.totalizadoresLabel}>Impuesto adicional</InputLabel>
              </Grid>
              <Grid item xs={7}>
                <FormControl fullWidth>
                  <TextField className={classes.dense} value={impuesto_adicional} disabled/>
                </FormControl>
              </Grid>
            </Grid>
          </div>
        </Grid>
        <Grid item sm={4} container direction="column" spacing={8} className={classes.gridContainer}>
          <div className={classes.totalizadores}>
              <Grid container>
                <Grid item xs={5}>
                  <InputLabel className={classes.totalizadoresLabel}>Monto neto</InputLabel>
                </Grid>
                <Grid item xs={7}>
                  <FormControl fullWidth>
                    <TextField className={classes.dense} disabled={true} value={neto} />
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={5}>
                  <InputLabel className={classes.totalizadoresLabel}>IVA (19%)</InputLabel>
                </Grid>
                <Grid item xs={7}>
                  <FormControl fullWidth>
                    <TextField className={classes.dense} disabled={true} value={iva}/>
                  </FormControl>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={5}>
                  <InputLabel className={classes.totalizadoresLabel}>Total</InputLabel>
                </Grid>
                <Grid item xs={7}>
                  <FormControl fullWidth>
                    <TextField className={classes.dense} disabled={true} value={total}/>
                  </FormControl>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid style={{marginTop: "10px"}} sm={12}>
          <ExpansionPanel defaultExpanded={true}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>
                Referencias
              </Typography>
              <Badge className={classes.badgeStyle} color="secondary" badgeContent={referencias.length}>
              </Badge>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Grid sm={12} container direction="column" spacing={8} className={classes.gridContainer}>
                  <Grid item>
                    <Grid container>
                      <Grid item sm={12}>
                        <Tooltip title="Agregar item">
                          <Button variant="contained" color="primary" onClick={(evt) => {
                              evt.preventDefault();
                              pushReferencia({ tipoDoc: null, numeroDoc: null, fechaDoc: "", Rut: null });
                            }} className={classes.button}>
                            <Icon aria-label="Add" className={classes.iconHover}>add</Icon>
                            Agregar referencia
                          </Button>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={12}>
                      <div style={{maxWidth:"100%", overflowX: "auto"}}>
                        <Table className={classes.table}>
                          <TableHead>
                            <TableRow>
                              <TableCell className={classes.tableCell}>
                                Tipo doc.
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                N° doc.
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                Fecha
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                Cod. Referencia
                              </TableCell>
                              <TableCell className={classes.tableCell}>
                                Razón Referencia
                              </TableCell>
                              <TableCell className={classes.tableCell}></TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {
                              referencias.map((item, index)=> {
                                return (
                                <TableRow>
                                  <TableCell>
                                    {item.tipoDoc!=null&&!Number.isInteger(item.tipoDoc)?<TextField inputProps={{maxLength: 3}} onBlur={e => {
                                      if(e.target.value == ""){
                                        var a = {target:{value:null}}
                                        changeReferenciaData(index, "tipoDoc", a)
                                      }
                                  }} onChange={(evt)=> { changeReferenciaData(index, "tipoDoc", evt) }} value={item.tipoDoc} />:<TextField
                                              select
                                              fullWidth
                                              margin="dense"
                                              InputLabelProps={{ shrink: true }}
                                              value={item.tipoDoc}
                                              title={(_.findWhere(layoutContext.state.tiposDoc, { ID: item.tipoDoc }) || { Nombre: "" }).Nombre}
                                              onChange={(evt)=> { changeReferenciaData(index, "tipoDoc", evt) }}>
                                              {layoutContext.state.tiposDoc.map(option => (
                                                <MenuItem key={option.ID} value={option.ID}>
                                                  {option.Nombre}
                                                </MenuItem>
                                              ))}
                                              <MenuItem key={-1} value={""}>
                                                  Otro
                                              </MenuItem>
                                              </TextField>}</TableCell>
                                  <TableCell className={classes.tableCell}><TextField  onChange={(evt)=>{ changeReferenciaData(index, "numeroDoc", evt) }} value={item.numeroDoc} /></TableCell>
                                  <TableCell className={classes.tableCell}><TextField fullWidth type="date" onChange={(evt)=>{ changeReferenciaData(index, "fechaDoc", evt) }} value={item.fechaDoc || ""} InputLabelProps={{ shrink: true }} /></TableCell>
                                  <TableCell className={classes.tableCell}><TextField
                                              select
                                              fullWidth
                                              margin="dense"
                                              InputLabelProps={{ shrink: true }}
                                              value={item.codReferencia}
                                              title={(_.findWhere(codigosReferencia, { codReferencia: item.codReferencia }) || { NombreCodReferencia: "" }).NombreCodReferencia}
                                              onChange={(evt)=> { changeReferenciaData(index, "codReferencia", evt) }}>
                                              {codigosReferencia.map(option => (
                                                <MenuItem key={option.CodReferencia} value={option.CodReferencia}>
                                                  {option.NombreCodReferencia}
                                                </MenuItem>
                                              ))}
                                            </TextField></TableCell>
                                  <TableCell className={classes.tableCell}><TextField  fullWidth onChange={(evt)=>{ changeReferenciaData(index, "razonReferencia", evt) }} value={item.razonReferencia} /></TableCell>
                                  <TableCell className={classes.tableCellDelete} onClick={() => {
                                      let ix = index;
                                      removeReferencia(index);
                                    }}>
                                      <Icon color="secondary">
                                        <DeleteIcon />
                                      </Icon>
                                  </TableCell>
                                </TableRow>
                                )
                              })
                            }
                          </TableBody>
                        </Table>
                      </div>
                    </Grid>
                  </Grid>
              </Grid>
            </ExpansionPanelDetails>
          </ExpansionPanel>
          {(tipoDespacho == 2 || tipoDespacho == 3 ) && <ExpansionPanel defaultExpanded={false}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>
                Transporte
              </Typography>
              <Typography color="textSecondary">&nbsp;&nbsp;&nbsp;</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Grid sm={12} container spacing={8} className={classes.gridContainer}>
                  <Grid item xs = {4}>
                    <FormControl fullWidth>
                      <TextField label="Patente" inputProps={{maxLength: 8}} onChange={e=>setTransporte({...(transporte||{}),Patente:e.target.value})} className={classes.dense} value={(transporte||{}).Patente||""} />
                    </FormControl>
                  </Grid>
                  <Grid item xs = {4}>
                    <FormControl fullWidth>
                      <TextField label="Rut Transportista" helperText="Sin puntos, con guión" inputProps={{maxLength: 10}} onBlur={e=>setTransporte({...(transporte||{}),RUTTrans:formateaRut((transporte||{}).RUTTrans).replace(/\./g,"")})} onChange={e=>setTransporte({...(transporte||{}),RUTTrans:e.target.value})} className={classes.dense} value={(transporte||{}).RUTTrans||""} />
                    </FormControl>
                  </Grid>
                  <Grid item xs = {4}></Grid>
                  <Grid item xs = {4}>
                    <FormControl fullWidth>
                      <TextField label="Rut Chofer" helperText="Sin puntos, con guión" inputProps={{maxLength: 10}} onBlur={e=>setTransporte({...(transporte||{}),Chofer:{...(transporte||{}).Chofer,RUTChofer:formateaRut(((transporte||{}).Chofer||{}).RUTChofer).replace(/\./g,"")}})} onChange={e=>setTransporte({...(transporte||{}),Chofer:{...(transporte||{}).Chofer,RUTChofer:e.target.value}})} className={classes.dense} value={((transporte||{}).Chofer||{}).RUTChofer||""} />
                    </FormControl>
                  </Grid>
                  <Grid item xs = {4}>
                    <FormControl fullWidth>
                      <TextField label="Nombre Chofer" inputProps={{maxLength: 30}} onChange={e=>setTransporte({...(transporte||{}),Chofer:{...(transporte||{}).Chofer,NombreChofer:e.target.value}})} className={classes.dense} value={((transporte||{}).Chofer||{}).NombreChofer||""} />
                    </FormControl>
                  </Grid>
                  <Grid item xs = {4}></Grid>
                  <Grid item xs = {4}>
                    <FormControl fullWidth>
                      <TextField label="Dirección de Destino" inputProps={{maxLength: 70}} onChange={e=>setTransporte({...(transporte||{}),DirDest:e.target.value})} className={classes.dense} value={(transporte||{}).DirDest||""} />
                    </FormControl>
                  </Grid>
                  <Grid item xs = {4}>
                    <FormControl fullWidth>
                      <TextField label="Comuna de Destino" inputProps={{maxLength: 20}} onChange={e=>setTransporte({...(transporte||{}),CmnaDest:e.target.value})} className={classes.dense} value={(transporte||{}).CmnaDest||""} />
                    </FormControl>
                  </Grid>
                  <Grid item xs = {4}>
                    <FormControl fullWidth>
                      <TextField label="Ciudad de Destino" inputProps={{maxLength: 20}} onChange={e=>setTransporte({...(transporte||{}),CiudadDest:e.target.value})} className={classes.dense} value={(transporte||{}).CiudadDest||""} />
                    </FormControl>
                  </Grid>
              </Grid>
            </ExpansionPanelDetails>
          </ExpansionPanel>}
        </Grid>
      </Grid>
    </Grid>
  );

  const footer = auth.isAuthenticated && (
    <DialogActions>
      <Button onClick={handleToggleModal} color="secondary" autoFocus>
        Cancelar
      </Button>
      <Button onClick={toggleConfirmBorrador} disabled={creando} color="primary" autoFocus>
      {esAdmin?"Guardar":"Emitir"}
      </Button>
    </DialogActions>
  );

  return (
    <div>
      <CloseButtonDialog open={layoutContext.state.openNuevaVenta} onClose={handleToggleModal} closeButton title={layoutContext.state.dteData? "Enviar borrador" : "Nuevo Documento"} content={content} footer={footer} fullWidth fullHeight size="lg" />
    </div>
  );
}

export default withStyles(styles)(React.memo(Index));